import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1984945a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-title-box" }, "添加商品分组", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-remake" }, "最多添加 10 个导航，拖动选中的导航可对其排序", -1))
const _hoisted_3 = { class: "image-drag-box" }
const _hoisted_4 = { class: "image-item-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商品来源", -1))
const _hoisted_6 = { style: {"flex":"1"} }
const _hoisted_7 = { class: "drag-box" }
const _hoisted_8 = { class: "image-item-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "菜单名称", -1))
const _hoisted_10 = { class: "image-item-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "显示个数", -1))
const _hoisted_12 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_13 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_14 = {
  key: 0,
  style: {"padding-left":"25px"}
}
const _hoisted_15 = { style: {"display":"flex","align-items":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryName = _resolveComponent("CategoryName")!
  const _component_Fold = _resolveComponent("Fold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_ui_close_btn = _resolveComponent("ui-close-btn")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ui_layout2 = _resolveComponent("ui-layout2")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_ui_layout1 = _resolveComponent("ui-layout1")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", {
      class: "image-group-list",
      style: _normalizeStyle(_ctx.modelValue.list.length == 0 ? { marginTop: 0, marginBottom: 0 } : {})
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_draggable, {
          modelValue: _ctx.modelValue.list,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.list) = $event)),
          handle: ".drag-box"
        }, {
          item: _withCtx(({ element, index }) => [
            (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "image-group-item-box"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CategoryName, {
                    modelValue: element.id,
                    onClick: ($event: any) => (_ctx.changeCategory(index))
                  }, null, 8, ["modelValue", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Fold)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_el_input, {
                  modelValue: element.name,
                  "onUpdate:modelValue": ($event: any) => ((element.name) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_el_checkbox, {
                  modelValue: element.all,
                  "onUpdate:modelValue": ($event: any) => ((element.all) = $event),
                  style: {"margin-right":"10px"},
                  "true-label": 1,
                  "false-label": 0
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("全部")
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                (!element.all)
                  ? (_openBlock(), _createBlock(_component_el_input_number, {
                      key: 0,
                      modelValue: element.count,
                      "onUpdate:modelValue": ($event: any) => ((element.count) = $event),
                      min: 1,
                      style: {"width":"100px"},
                      max: 50
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_ui_close_btn, {
                onClick: _withModifiers(($event: any) => (_ctx.removeItem(index)), ["stop"])
              }, null, 8, ["onClick"])
            ]))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_button, { onClick: _ctx.addCategory }, {
        default: _withCtx(() => [
          _createTextVNode("添加商品分组")
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 4),
    _createVNode(_component_ui_layout2, {
      title: "展示模板",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.modelValue.showType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.showType) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "top" }, {
              default: _withCtx(() => [
                _createTextVNode("顶部菜单")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "left" }, {
              default: _withCtx(() => [
                _createTextVNode("左侧菜单")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (_ctx.modelValue.showType == 'top')
      ? (_openBlock(), _createBlock(_component_ui_layout2, {
          key: 0,
          title: "全部分组"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.modelValue.showAll,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelValue.showAll) = $event)),
              "true-label": 1,
              "false-label": 0
            }, {
              default: _withCtx(() => [
                _createTextVNode("显示全部")
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_divider),
    (_ctx.modelValue.showType == 'top')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_ui_layout2, { title: "列表样式" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.modelValue.listMode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelValue.listMode) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, { label: "small" }, {
                    default: _withCtx(() => [
                      _createTextVNode("小图")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, { label: "big" }, {
                    default: _withCtx(() => [
                      _createTextVNode("大图")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, { label: "minix" }, {
                    default: _withCtx(() => [
                      _createTextVNode("一大两小")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, { label: "list" }, {
                    default: _withCtx(() => [
                      _createTextVNode("列表")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_divider)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_ui_layout2, {
      title: "图片边角",
      class: "view-item-box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.modelValue.imageRadius,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelValue.imageRadius) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "0" }, {
              default: _withCtx(() => [
                _createTextVNode("直角")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "8px" }, {
              default: _withCtx(() => [
                _createTextVNode("圆角")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_ui_layout1, {
      title: "页面边距",
      class: "view-item-box"
    }, {
      content: _withCtx(() => [
        _createVNode(_component_el_slider, {
          style: {"margin-left":"10px"},
          modelValue: _ctx.modelValue.pageGap,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelValue.pageGap) = $event)),
          "show-input": "",
          class: "slider-style-box",
          max: 30,
          "show-input-controls": false
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_ui_layout1, {
      title: "图片间距",
      class: "view-item-box"
    }, {
      content: _withCtx(() => [
        _createVNode(_component_el_slider, {
          style: {"margin-left":"10px"},
          modelValue: _ctx.modelValue.imageGap,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelValue.imageGap) = $event)),
          "show-input": "",
          class: "slider-style-box",
          max: 30,
          "show-input-controls": false
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_ui_layout1, { class: "view-item-box" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.modelValue.showTitle,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelValue.showTitle) = $event)),
            "true-label": 1,
            "false-label": 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("显示标题")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ui_layout1, { class: "view-item-box" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.modelValue.showBuyBtn,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelValue.showBuyBtn) = $event)),
            "true-label": 1,
            "false-label": 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("显示购买按钮")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      content: _withCtx(() => [
        (_ctx.modelValue.showBuyBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_radio, {
                  modelValue: _ctx.modelValue.btnStyle,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelValue.btnStyle) = $event)),
                  label: item.value,
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "label"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ui_layout1, { class: "view-item-box" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.modelValue.showPrice,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelValue.showPrice) = $event)),
            "true-label": 1,
            "false-label": 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("显示价格")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}